export const withRetry = async (fun: () => any, maxRetries: number): Promise<any> => {
    return new Promise(async (resolve, reject) => {
        let attempt = 0;
        do {
            try {
                const data = await fun();
                resolve(data);
                break;
            } catch (err) {
                attempt++;
                if (attempt > maxRetries) {
                    reject(err);
                    break;
                } else {
                    await sleep(1);
                }
            }
        } while (attempt <= maxRetries);
    });
}

export const sleep = (min: number) => {
    return new Promise((resolve) => {
        setTimeout(() => resolve(true), min * 60 * 1000);
    });
}


export const getFormattedDate = (date: Date) => {
    const months = ['Jan', 'Feb', 'March', 'April', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const year = date.getFullYear();
    const month = date.getUTCMonth(); // Months are 0-based
    const day = String(date.getUTCDate()).padStart(2, '0');
  
    return `${months[month]} ${day}, ${year}`;
}

export const getDateString = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getUTCDate()).padStart(2, '0');
  
    return `${year}-${month}-${day}`;
}
 
export const isDateString = (str) => {
    const date = new Date(str);
    return !isNaN(date.getTime());
}

export const calculatePercentage = (part: number, whole: number) => {
    return parseFloat((((part - whole) / whole) * 100).toFixed(2));
}

export const getStartDate = (period: string, endDate: Date) => {
    if (period === '1D') {
        endDate.setDate(endDate.getDate() - 1);
    } else if (period === '1W') {
        endDate.setDate(endDate.getUTCDate() - 7);
    } else if (period === '1M') {
        endDate.setMonth(endDate.getUTCMonth() - 1);
    } else if (period === '3M') {
        endDate.setMonth(endDate.getUTCMonth() - 3);
    } else if (period === 'YTD') {
        endDate = new Date(`01-01-${endDate.getFullYear()}`);
    } else if (period === '6M') {
        endDate.setMonth(endDate.getUTCMonth() - 6);
    } else if (period === '1Y' || period === '1A') {
        endDate.setFullYear(endDate.getFullYear() - 1);
    }

    return `${getDateString(endDate)}T06:30:00Z`;
}

export const formateTimestamp = (t: number | string) => {
    const date = new Date(typeof t === 'number' ? parseInt(`${t}000`) : t);
    const months = ['Jan', 'Feb', 'March', 'April', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const year = date.getFullYear();
    const month = date.getUTCMonth(); // Months are 0-based
    const day = String(date.getUTCDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${months[month]} ${day}, ${year} ${hours}:${minutes}:${seconds}`;
}

export const getInDoller = (price) => {
    const priceString = price.toFixed(2);
    if (price < 0) {
        return `-$${priceString.slice(1)}`;
    }
    return `$${priceString}`;
}

export const dateSort = (direction: 'asc' | 'desc' | null, vala: string | number, valb: string | number) => {
    if (!direction) return 0;
    let aVal;
    let bVal;

    if (isDateString(vala) && isDateString(valb)) {
        aVal = new Date(vala).getTime();
        bVal = new Date(valb).getTime();
    } else if (!isNaN(vala as number) && !isNaN(valb as number)) {
        aVal = parseFloat(vala as string);
        bVal = parseFloat(valb as string);
    } else if (typeof vala === "string" && typeof valb === "string") {
        aVal = vala.toUpperCase();
        bVal = valb.toUpperCase();
    } else {
        aVal = vala;
        aVal = valb;
    }

    if (aVal < bVal) return direction === 'asc' ? -1 : 1;
    if (aVal > bVal) return direction === 'asc' ? 1 : -1;
    
    return 0;
}